module.exports = window.dnn.nodeModules.React;